import * as React from "react";
import {
  Form as FormikForm,
  Formik,
  FormikValues,
  FormikConfig,
  FormikProps,
} from "formik";

import type { JSX } from "react";

interface FormProps<TValues> extends FormikConfig<TValues> {
  className?: string;
}

const Form = <TValues extends FormikValues>({
  children,
  className,
  ...props
}: FormProps<TValues>): JSX.Element => (
  <Formik {...props}>
    {(childrenProps: FormikProps<TValues>) => (
      // https://github.com/jaredpalmer/formik/issues/2120
      // eslint-disable-next-line
      // @ts-ignore
      <FormikForm className={className}>
        {typeof children === "function" ? children(childrenProps) : children}
      </FormikForm>
    )}
  </Formik>
);

export default Form;
